import {
  getProfileOptionLabel,
  PROFILE_CANAL_OPTIONS,
  PROFILE_TIPO_PESSOA_OPTIONS,
} from "views/admin/constants/profile-options";

// Representante vem primeiro: a carteira dele define quais lojas aparecem na aba Lojista.
export const ACCESS_TAB_TYPES = [
  { value: "REPRESENTANTE", label: "Representante" },
  { value: "LOJISTA", label: "Lojista" },
];

const PERSON_TYPES_REQUIRING_LINK = ["LOJISTA", "REPRESENTANTE"];

export function aggregateProfileAccess(perfisVinculados = []) {
  const canais = new Set();
  const tiposPessoa = new Set();

  perfisVinculados.forEach((perfil) => {
    (perfil?.Canais || []).forEach((canal) => canais.add(canal));
    (perfil?.TiposPessoa || []).forEach((tipo) => tiposPessoa.add(tipo));
  });

  return {
    canais: Array.from(canais),
    tiposPessoa: Array.from(tiposPessoa),
  };
}

export function getVisibleAccessTabs(tiposPessoa = []) {
  return ACCESS_TAB_TYPES.filter((tab) => tiposPessoa.includes(tab.value));
}

export function requiresPersonLink(tiposPessoa = []) {
  return PERSON_TYPES_REQUIRING_LINK.some((tipo) => tiposPessoa.includes(tipo));
}

export function isInternoKsaOnly(tiposPessoa = []) {
  if (!tiposPessoa.length) {
    return false;
  }

  const externalTypes = PERSON_TYPES_REQUIRING_LINK.filter((tipo) =>
    tiposPessoa.includes(tipo),
  );

  return externalTypes.length === 0;
}

export function getCanaisPerfilParam(canais = []) {
  return canais.filter(Boolean).join(",");
}

export function formatProfileAccessSummary(profileAccess) {
  const canaisLabels = profileAccess.canais.map((canal) =>
    getProfileOptionLabel(PROFILE_CANAL_OPTIONS, canal),
  );
  const tiposLabels = profileAccess.tiposPessoa.map((tipo) =>
    getProfileOptionLabel(PROFILE_TIPO_PESSOA_OPTIONS, tipo),
  );

  return {
    canaisLabels,
    tiposLabels,
  };
}

export function createEmptyPeopleByType() {
  return {
    LOJISTA: [],
    REPRESENTANTE: [],
  };
}

export function mergePeopleByType(peopleByType = {}) {
  const byId = new Map();

  Object.values(peopleByType).forEach((people) => {
    (people || []).forEach((person) => {
      if (person?.Id != null) {
        byId.set(person.Id, person);
      }
    });
  });

  return Array.from(byId.values());
}

export function validateAccessStep({ profileAccess, peopleByType }) {
  if (isInternoKsaOnly(profileAccess.tiposPessoa)) {
    return null;
  }

  const visibleTabs = getVisibleAccessTabs(profileAccess.tiposPessoa);

  for (const tab of visibleTabs) {
    const linked = peopleByType[tab.value] || [];

    if (linked.length === 0) {
      return `Selecione ao menos uma pessoa do tipo ${tab.label}.`;
    }
  }

  return null;
}
